module.exports = window["wc"]["blocksComponents"];